@if (pageLoading()) {
  <div class="flex justify-center">
    <p-progressSpinner styleClass="w-4rem" />
  </div>
}
<div [innerHTML]="html()" class="help-content"></div>
